import { render, staticRenderFns } from "./ShowRzM.vue?vue&type=template&id=684fced5&scoped=true&"
import script from "./ShowRzM.vue?vue&type=script&lang=js&"
export * from "./ShowRzM.vue?vue&type=script&lang=js&"
import style0 from "./ShowRzM.vue?vue&type=style&index=0&id=684fced5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684fced5",
  null
  
)

component.options.__file = "ShowRzM.vue"
export default component.exports